import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
export default function HashNavigation(){
  const {pathname,hash}=useLocation();
  // Disable native restoration so it cannot restore the previous route's offset
  // after our router transition. Restore the browser setting on unmount.
  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    return () => { window.history.scrollRestoration = previous; };
  }, []);
  useLayoutEffect(()=>{
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    if(!hash)return;
    const scroll=()=>{const target=document.getElementById(hash.slice(1));if(!target)return false;target.scrollIntoView({behavior:'instant'});return true;};
    if(scroll())return;
    const observer=new MutationObserver(()=>{if(scroll())observer.disconnect();});
    observer.observe(document.body,{childList:true,subtree:true});
    const timeout=setTimeout(()=>observer.disconnect(),5000);
    return ()=>{observer.disconnect();clearTimeout(timeout);};
  },[pathname,hash]);
  return null;
}
